<template>
  <div>
    <div v-if="dado && dado.id_imposto != 100 && !dado.texto_inaplicabilidade" class="separador"></div>
  </div>
</template>

<script>
export default {
  name: 'Separador',

  props: {
    dado: Object | Array,
    classe: String,
    seleciona: Function,
    nameRadio: String,
    edita: Function,
  },

}

</script>